import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import currencyFormat from 'functions/currencyFormat'

import StarRating from 'components/StarRating'

import CampaignPlaceholder from 'assets/images/campaign/campaign_image_400x400-1.png'
import styles from './styles.scss'

const Review = (props) => {
  const {
    campaign: {
      address, default_image, hide_sold_price, sold_price, suburb_name,
    },
    large,
    review: {
      body, rating, reviewer_name, title,
    },
  } = props

  // Condensed Version
  if (!large){
    return (
      <div className={classnames(styles.root, styles.condensed)}>
        <div className={styles.left}>
          <span className={styles.address}>
            {address}, {suburb_name}
          </span>
          <span className={styles.price}>
            {!hide_sold_price && sold_price ? ` - Sold ${currencyFormat(sold_price, '$0,0')}` : 'Undisclosed'}
          </span>
        </div>

        <div className={styles.right}>
          <span className={styles.stars}>
            <StarRating value={rating} />
          </span>
          <span className={styles.reviewer}>{reviewer_name}</span>
        </div>
      </div>
    )
  }

  // Large
  return (
    <div className={classnames(styles.root, styles.large)}>
      <div
        className={styles.image}
        style={{ backgroundImage: default_image ? `url(${default_image})` : `url(${CampaignPlaceholder})` }}
      >
        <div className={styles.overlay}>
          <span className={styles.vendors}>{reviewer_name}</span>
          <span className={styles.address}>
            {address}
            {!hide_sold_price && sold_price && ` - Sold ${currencyFormat(sold_price, '$0,0')}`}
          </span>
        </div>
      </div>

      <div className={styles.review}>
        <span className={styles.stars}>
          <StarRating value={rating} />
        </span>
        <span className={styles.title}>{title}</span>
        <span className={styles.body}>{body}</span>
      </div>
    </div>
  )
}

Review.propTypes = {
  campaign: PropTypes.object.isRequired,
  large: PropTypes.bool,
  review: PropTypes.object.isRequired,
}

export default Review
